
(function documentTypeControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeModifyController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminDocumentTypeService', 'authExtend', 'functionService',
            function documentTypeController($scope, config, $state, $translate, errors, $stateParams, adminDocumentTypeService, authExtend, functionService) {
                $scope.canSetMaxVersions = authExtend.isInRole('DOCUMENTTYPE MAX VERSIONS');
                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                $scope.documentType = {
                    app: []
                };

                $scope.title = 'DocumentTypeModify';

                if ($scope.allApps) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminDocumentTypeService.getById($stateParams.id, 'Put').then(function (result) {
                    $scope.documentType = result;
                    $scope.documentType.maxDocumentVersion = $scope.documentType.maxDocumentVersion == null ? 0 : $scope.documentType.maxDocumentVersion;

                    $scope.documentType.app = [];
                    $scope.tempApp = [];
                    if ($scope.optionApps) {
                        $scope.documentType.applications.forEach(function (item) {
                            $scope.documentType.app.push(item.applicationId);

                            var tempAppItem = $scope.optionApps.filter(function (optionApp) { return optionApp.id == item.applicationId; });
                            $scope.optionApps[$scope.optionApps.indexOf(tempAppItem[0])].isAlreadyAdded = true;
                            $scope.tempApp.push(tempAppItem[0]);
                        });
                    }
                }, function (error) {
                    errors.showError(error);
                    $state.go('document-type-find');
                });

                $scope.selectApp = function (item) {
                    if (!Array.isArray($scope.tempApp)) {
                        $scope.tempApp = [];
                    }

                    $scope.documentType.applications.push({ applicationId: item.id });

                    $scope.tempApp.push(item)
                };

                $scope.removeApp = function (item) {
                    var index = $scope.tempApp.indexOf(item);
                    if (index > -1) {
                        $scope.tempApp.splice(index, 1);
                    }

                    var appItem = $scope.documentType.applications.filter(function (app)
                    {
                        return app.applicationId == item.id;
                    });
                    var index = $scope.documentType.applications.indexOf(appItem[0]);
                    if (index > -1 && !appItem[0].id) {
                        $scope.documentType.applications.splice(index, 1);
                    }

                };


                $scope.save = function () {

                    if (!$scope.documentTypeForm.$valid) {
                        $scope.documentTypeForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    $scope.documentType.maxDocumentVersion = $scope.documentType.maxDocumentVersion == 0 ? null : $scope.documentType.maxDocumentVersion;
                    
                    adminDocumentTypeService.modify($scope.documentType).then(function () {
                        $state.go('document-type-find', { name: $scope.documentType.name });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.cancel = function () {
                    $state.go('document-type-find');
                };

            }
        ]);
})();